// Auto generated file, do not manually modify!
// com.hotpads.capps.enums.IncomeType

export enum IncomeType {
  CONTRACTOR_SELF_EMPLOYED = 'CONTRACTOR_SELF_EMPLOYED',
  EMPLOYMENT = 'EMPLOYMENT',
  HOUSING_VOUCHER = 'HOUSING_VOUCHER',
  OTHER = 'OTHER',
}

export const IncomeType_values = [
  IncomeType.CONTRACTOR_SELF_EMPLOYED,
  IncomeType.EMPLOYMENT,
  IncomeType.HOUSING_VOUCHER,
  IncomeType.OTHER,
] as const;
